"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2993,6000,4987,8104],{

/***/ 76000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAgent = function SvgAgent(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "CurrentColor"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4 5.333A2.667 2.667 0 1 0 4 0a2.667 2.667 0 0 0 0 5.333ZM4 .667a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.834 6.697a2.133 2.133 0 1 0 0-4.266 2.133 2.133 0 0 0 0 4.266Zm0-3.606a1.467 1.467 0 1 1 0 2.933 1.467 1.467 0 0 1 0-2.933Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.667 7.212H8a2.358 2.358 0 0 0-.282.033A2.327 2.327 0 0 0 5.667 6H2.333A2.333 2.333 0 0 0 0 8.333v3.334A.333.333 0 0 0 .333 12h11.334a.333.333 0 0 0 .333-.333V9.545a2.333 2.333 0 0 0-2.333-2.333Zm-9 1.121a1.667 1.667 0 0 1 1.666-1.666h3.334a1.667 1.667 0 0 1 1.666 1.666v3H.667v-3Zm10.666 3H8v-3c0-.15-.016-.301-.045-.449.015 0 .03-.005.045-.005h1.667a1.667 1.667 0 0 1 1.666 1.666v1.788Z"
  }))));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgAgent);

/***/ }),

/***/ 54987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBathroom = function SvgBathroom(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M13.665 6.333a1 1 0 0 0-1-1H2.332v-3.99a.663.663 0 0 1 .2-.476.634.634 0 0 1 .475-.193.667.667 0 0 1 .661.667v.051a1 1 0 0 0-.67.941V3a.333.333 0 0 0 .334.333h1.333A.333.333 0 0 0 5 3v-.667a1 1 0 0 0-.667-.938v-.05A1.333 1.333 0 0 0 3.012.01a1.285 1.285 0 0 0-.951.386 1.321 1.321 0 0 0-.396.946v3.99h-.333a1 1 0 0 0-.252 1.964l.813 2.441c.174.517.524.956.99 1.24l-.454.453a.334.334 0 0 0 .472.472l.644-.645c.184.048.372.073.562.075H9.89c.19-.002.378-.027.561-.075l.644.645a.334.334 0 0 0 .472-.472l-.452-.452a2.33 2.33 0 0 0 .988-1.24l.814-2.442a1 1 0 0 0 .748-.964ZM4.332 2.667h-.667v-.334a.333.333 0 1 1 .667 0v.334Zm7.14 6.86a1.667 1.667 0 0 1-1.581 1.14H4.107a1.667 1.667 0 0 1-1.58-1.14l-.732-2.194h10.408l-.731 2.194Zm1.194-2.86H1.332a.333.333 0 0 1 0-.667h11.333a.333.333 0 1 1 0 .667Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgBathroom);

/***/ }),

/***/ 38104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBed = function SvgBed(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 11"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M14 4.367v-3.7a.333.333 0 0 0-.334-.334H2.333A.333.333 0 0 0 2 .667v3.7A1.67 1.67 0 0 0 .667 6v4a.333.333 0 0 0 .333.333h1.333A.333.333 0 0 0 2.666 10V8.333h10.667V10a.333.333 0 0 0 .333.333H15a.333.333 0 0 0 .333-.333V6A1.67 1.67 0 0 0 14 4.367ZM2.666 1h10.667v3.333H12V2.667a.333.333 0 0 0-.334-.334H9a.333.333 0 0 0-.334.334v1.666H7.333V2.667A.333.333 0 0 0 7 2.333H4.333A.333.333 0 0 0 4 2.667v1.666H2.667V1Zm8.667 3.333h-2V3h2v1.333Zm-4.667 0h-2V3h2v1.333Zm8 5.334H14V8a.333.333 0 0 0-.334-.333H2.333A.333.333 0 0 0 2 8v1.667h-.667V6a1.001 1.001 0 0 1 1-1h11.334a1.001 1.001 0 0 1 1 1v3.667Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgBed);

/***/ }),

/***/ 92993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ apartment_card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/molecules/card/index.ts + 1 modules
var card = __webpack_require__(25649);
// EXTERNAL MODULE: ./public/assets/icons/Agent.svg
var Agent = __webpack_require__(76000);
// EXTERNAL MODULE: ./public/assets/icons/ArrowDownPri.svg
var ArrowDownPri = __webpack_require__(36094);
// EXTERNAL MODULE: ./public/assets/icons/Bathroom.svg
var Bathroom = __webpack_require__(54987);
// EXTERNAL MODULE: ./public/assets/icons/Bed.svg
var Bed = __webpack_require__(38104);
;// CONCATENATED MODULE: ./components/organisms/apartment-card/ApartmentCard.tsx











var PopUpBookingLavanda = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(2667), __webpack_require__.e(9501), __webpack_require__.e(735), __webpack_require__.e(8852)]).then(__webpack_require__.bind(__webpack_require__, 80735));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80735)
            ];
        }
    },
    ssr: false
});
var PopUpIframe = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(8230)]).then(__webpack_require__.bind(__webpack_require__, 48230));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48230)
            ];
        }
    },
    ssr: false
});
/**
 * ApartmentsCard
 */ var ApartmentCard = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, images = param.images, title = param.title, desc = param.desc, // size,
    monthday = param.monthday, people = param.people, bathrooms = param.bathrooms, beds = param.beds, equipment = param.equipment, features = param.features, price = param.price, tourLink = param.tourLink, accommodationSelect = param.accommodationSelect, buildingSelect = param.buildingSelect, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, buttonText = param.buttonText, _buttonLink = param.buttonLink, buttonLink = _buttonLink === void 0 ? "" : _buttonLink, _buttonWidth = param.// metersFrom,
    buttonWidth, buttonWidth = _buttonWidth === void 0 ? 100 : _buttonWidth, _cardOrientation = param.cardOrientation, cardOrientation = _cardOrientation === void 0 ? "column" : _cardOrientation, lavandaId = param.lavandaId, buildingId = param.buildingId, _landing = param.landing, landing = _landing === void 0 ? false : _landing, _rotated = param.rotated, rotated = _rotated === void 0 ? true : _rotated;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var ref = (0,react.useState)(false), expanded = ref[0], setExpanded = ref[1];
    var ref1 = (0,react.useState)(false), formOpen = ref1[0], setFormOpen = ref1[1];
    var ref2 = (0,react.useState)(false), iframePopUpState = ref2[0], setIframePopUpState = ref2[1];
    var popUpToggle = function() {
        setFormOpen(!formOpen);
    };
    var iframeToggle = function() {
        setIframePopUpState(!iframePopUpState);
    };
    // TODO: CAMBIAR PARA APARTMENTS
    // features = [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpBookingLavanda, {
                apartmentsByBuilding: accommodationSelect,
                buildings: buildingSelect,
                show: formOpen,
                onClose: popUpToggle,
                defaultBuilding: buildingId,
                defaultApartment: lavandaId
            }),
            tourLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpIframe, {
                setState: iframeToggle,
                src: tourLink,
                state: iframePopUpState
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                className: "h-auto text-primary-500 md:!h-full ".concat(className, " "),
                classNames: {
                    multimedia: cardOrientation === "row" ? "h-[205px] md:h-full" : "h-[205px]"
                },
                multimediaProps: {
                    images: images,
                    roundedPosition: "top"
                },
                backgroundColor: "white",
                orientation: cardOrientation,
                rotated: rotated,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(cardOrientation === "row" ? " flex h-auto flex-col justify-between md:h-full " : " flex h-full flex-col justify-between "),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-3 flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-heading text-heading--h4 ".concat( true ? "font-normal antialiased" : 0),
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-body text-body--primary ".concat( true && "text-[#3A7A78]"),
                                        children: desc
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-body apartments_card-features text-body--secondary",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex w-full justify-between gap-5 ".concat(cardOrientation === "column" ? "flex-row" : "flex-col"),
                                        children: [
                                             true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-4",
                                                children: [
                                                    people && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-row items-center gap-1 font-light",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Agent["default"], {
                                                                width: 20
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "1-",
                                                                    people
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-row items-center gap-1 font-light",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bed["default"], {
                                                                width: 24
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: beds === null || beds === void 0 ? void 0 : beds.toString().replace("+dormitorios", "").replace("+dormitorio", "")
                                                            })
                                                        ]
                                                    }),
                                                    bathrooms && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-row items-center gap-1 font-light",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bathroom["default"], {
                                                                width: 20
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: bathrooms
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ 0,
                                            ((equipment === null || equipment === void 0 ? void 0 : equipment.length) > 0 || (features === null || features === void 0 ? void 0 : features.length) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-links text-links--small flex cursor-pointer flex-row items-center",
                                                onClick: function() {
                                                    return setExpanded(!expanded);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "apartments_card-desplegable",
                                                        children: !expanded ? t("components.organisms.apartmentsCard.seeMore") : t("components.organisms.apartmentsCard.seeLess")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownPri["default"], {
                                                        width: 15,
                                                        height: 21,
                                                        className: "".concat(expanded ? "-rotate-180" : "", " ")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                ((equipment === null || equipment === void 0 ? void 0 : equipment.length) > 0 || (features === null || features === void 0 ? void 0 : features.length) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: expanded ? "pb-5" : "hidden",
                                    children: [
                                        (equipment === null || equipment === void 0 ? void 0 : equipment.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "text-subtitle text-subtitle--small font-bold",
                                                    children: [
                                                        t("components.organisms.apartmentsCard.equipment"),
                                                        " "
                                                    ]
                                                }),
                                                equipment.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "apartments_card-icons",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                src: item.icon,
                                                                width: 20
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: item.text
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            ]
                                        }),
                                        (features === null || features === void 0 ? void 0 : features.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-4",
                                            children: features.map(function(feat, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className:  true ? "!text-[18px]" : 0,
                                                            children: feat.name
                                                        }),
                                                        feat.features.map(function(item, itmIndex) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "apartments_card-icons",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                        src: item.icon,
                                                                        width: 20
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: item.text
                                                                    }),
                                                                    " "
                                                                ]
                                                            }, "".concat(index, "-").concat(itmIndex));
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row justify-between",
                                            children: [
                                                price && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-body text-body--secondary ".concat( true && "text-[18px] font-normal"),
                                                            children: t("components.organisms.apartmentsCard.from")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-row",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-subtitle text-subtitle--small",
                                                                    children: price
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-body text-body--primary",
                                                                    children: monthday === "Month" ? t("components.organisms.apartmentsCard.perMonth") : t("components.organisms.apartmentsCard.perDay")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                tourLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                                    as: "button",
                                                    variant: "primary",
                                                    arrow: false,
                                                    underline: true,
                                                    onClick: iframeToggle,
                                                    children: t("components.organisms.apartmentsCard.tourLink")
                                                })
                                            ]
                                        }),
                                        landing ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "#",
                                            prefetch: false,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                    variant: "secondary",
                                                    size: "large",
                                                    style: {
                                                        width: "".concat(buttonWidth, "%")
                                                    },
                                                    children: buttonText
                                                })
                                            })
                                        }) : buttonLink && buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                            variant: "secondary",
                                            size: "large",
                                            "aria-disabled": disabled,
                                            style: {
                                                width: "".concat(buttonWidth, "%")
                                            },
                                            onClick: popUpToggle,
                                            children: buttonText
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
ApartmentCard.displayName = "ApartmentCard";

;// CONCATENATED MODULE: ./components/organisms/apartment-card/index.ts

/* harmony default export */ var apartment_card = (ApartmentCard);


/***/ })

}]);